const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Japanese%20manga%20style%20illustration%20of%20a%20young%20warrior%20standing%20on%20a%20cliff%20overlooking%20a%20vast%20fantasy%20landscape%20at%20sunset%2C%20warm%20golden%20and%20coral%20tones%2C%20detailed%20linework%2C%20epic%20composition%2C%20clean%20solid%20background&width=600&height=400&seq=carousel-01&orientation=landscape',
    title: '《剑与远方》',
    tag: '奇幻冒险',
    desc: '少年剑士踏上寻找传说的旅途，史诗级冒险故事',
    update: '连载至第87话',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20style%20romance%20scene%20with%20two%20characters%20sharing%20a%20tender%20moment%20under%20cherry%20blossoms%2C%20soft%20pastel%20pink%20and%20cream%20tones%2C%20dreamy%20atmosphere%2C%20clean%20minimal%20background%2C%20emotional%20storytelling&width=600&height=400&seq=carousel-02&orientation=landscape',
    title: '《心跳的频率》',
    tag: '恋爱甜宠',
    desc: '高甜校园恋爱物语，每一帧都是心动的感觉',
    update: '连载至第52话',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20style%20illustration%20of%20a%20cultivator%20in%20flowing%20robes%20surrounded%20by%20floating%20spiritual%20energy%20and%20golden%20light%2C%20ancient%20Chinese%20aesthetic%2C%20elegant%20composition%2C%20warm%20amber%20and%20cream%20tones&width=600&height=400&seq=carousel-03&orientation=landscape',
    title: '《修灵纪》',
    tag: '国漫精选',
    desc: '修真世界波澜壮阔，凡人少年逆天改命的传奇',
    update: '连载至第124话',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20thrilling%20suspense%20mystery%20manga%20style%20scene%20with%20a%20detective%20character%20in%20a%20dimly%20lit%20room%20examining%20clues%2C%20atmospheric%20lighting%2C%20warm%20shadow%20tones%2C%20tense%20composition%2C%20clean%20background&width=600&height=400&seq=carousel-04&orientation=landscape',
    title: '《暗影追踪》',
    tag: '悬疑推理',
    desc: '连环案件层层反转，天才侦探与罪犯的高智商对决',
    update: '连载至第38话',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20lively%20school%20life%20manga%20scene%20with%20a%20group%20of%20teenage%20friends%20laughing%20together%20in%20a%20classroom%20filled%20with%20warm%20sunlight%2C%20slice%20of%20life%20aesthetic%2C%20cheerful%20vibe%2C%20soft%20cream%20and%20coral%20tones&width=600&height=400&seq=carousel-05&orientation=landscape',
    title: '《青春日常》',
    tag: '校园日常',
    desc: '温暖治愈的校园群像故事，记录最美的青春时光',
    update: '连载至第65话',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20dynamic%20action%20manga%20scene%20with%20two%20warriors%20in%20an%20intense%20battle%20stance%2C%20explosive%20energy%20effects%2C%20warm%20coral%20and%20amber%20dynamic%20lines%2C%20powerful%20composition%2C%20clean%20contrast%20background&width=600&height=400&seq=carousel-06&orientation=landscape',
    title: '《星界战记》',
    tag: '热血战斗',
    desc: '星际战场热血激斗，守护人类最后的希望之光',
    update: '连载至第91话',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-xl md:text-3xl text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            编辑团队为你精选的优质漫画专题，每一部都值得深入阅读
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <a
              key={item.title}
              href="#carousel"
              className="group bg-background-50 rounded-lg overflow-hidden cursor-pointer transition-colors hover:bg-background-200/40"
            >
              <div className="relative w-full aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500/90 text-background-50 text-xs font-medium rounded-full">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <div className="flex items-center justify-between mb-1.5">
                  <h3 className="font-heading text-base text-foreground-950 whitespace-nowrap">{item.title}</h3>
                  <span className="text-xs text-accent-600 whitespace-nowrap">{item.update}</span>
                </div>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}